module.exports = __webpack_public_path__ + "static/media/location-pin-close.8ab02ec7.svg";